"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPromotionSchema = exports.AnimalPromotionSchema = exports.ProductPromotionDetailSchema = exports.AnimalPromotionDetailSchema = exports.LinkMobSchema = exports.LinkMobInfo = exports.GeneralPromotionDetails = exports.StorySchema = exports.MediaType = exports.StoryLogoType = exports.StatusEnum = void 0;
const zod_1 = require("zod");
const BusinessMisc = __importStar(require("../misc/business"));
const TokenMisc = __importStar(require("../misc/token"));
const product_1 = require("./product");
exports.StatusEnum = zod_1.z.enum(['draft', 'published']);
exports.StoryLogoType = zod_1.z.enum(['brand', 'user']);
exports.MediaType = zod_1.z.enum(['image', 'video']);
exports.StorySchema = zod_1.z.object({
    logo: zod_1.z.string().nullable(),
    logoType: exports.StoryLogoType.nullable(),
    image: zod_1.z.string().nullable(),
    headline: zod_1.z.array(zod_1.z.string()).length(3),
    content: zod_1.z.string(),
    milestones: zod_1.z.array(zod_1.z.object({
        title: zod_1.z.string(),
        details: zod_1.z.string(),
    })),
    additional: zod_1.z.array(zod_1.z.object({
        title: zod_1.z.string(),
        content: zod_1.z.string(),
        mediaType: exports.MediaType.nullable(),
        url: zod_1.z.string().nullable(),
    }))
});
exports.GeneralPromotionDetails = zod_1.z.object({
    status: exports.StatusEnum,
    archive: zod_1.z.boolean(),
    name: zod_1.z.string(),
    display: zod_1.z.object({
        footerImage: zod_1.z.string().nullable(),
        startDate: zod_1.z.string(),
        endDate: zod_1.z.string(), //  UTC timestampe e.g. 2021-08-26T16:17:47.533Z
    }),
    webCount: zod_1.z.number().optional(),
    consumerCount: zod_1.z.number().optional(),
    supplierCount: zod_1.z.number().optional(),
});
exports.LinkMobInfo = zod_1.z.object({
    LT: zod_1.z.boolean(),
    EU: zod_1.z.boolean(),
    angusVerified: zod_1.z.boolean(),
    BRD: zod_1.z.boolean().optional(),
    WHP: zod_1.z.boolean().optional(),
    WHP_ESI: zod_1.z.boolean().optional(),
    fiveInOne: zod_1.z.boolean().optional(),
    ERP: zod_1.z.boolean().optional(),
});
exports.LinkMobSchema = zod_1.z.object({
    mobName: zod_1.z.string(),
    mobId: zod_1.z.string(),
    createDate: zod_1.z.union([zod_1.z.date(), zod_1.z.string()]),
    info: exports.LinkMobInfo,
    calves: zod_1.z.array(exports.LinkMobInfo.merge(zod_1.z.object({
        rfid: zod_1.z.string(),
        sex: zod_1.z.string(),
    }))),
});
exports.AnimalPromotionDetailSchema = zod_1.z.object({
    type: zod_1.z.literal(BusinessMisc.IndustryTypeSchema.enum.ANIMALS),
    templateType: zod_1.z.string(),
    brand: TokenMisc.ExternalIdsSchema,
    story: exports.StorySchema,
    mob: zod_1.z.object({
        media: zod_1.z.object({
            item: exports.MediaType,
            url: zod_1.z.string(),
        }),
        linkMob: exports.LinkMobSchema.nullable(),
        display: zod_1.z.object({
            isMob: zod_1.z.boolean(),
            isAnimal: zod_1.z.boolean()
        }),
        signed: zod_1.z.boolean(),
        msa: zod_1.z.boolean(),
        attachment: zod_1.z.array(product_1.iProductPageAttachmentSchema),
    }),
});
exports.ProductPromotionDetailSchema = zod_1.z.object({
    type: zod_1.z.literal(BusinessMisc.IndustryTypeSchema.enum.PRODUCTS),
    product: TokenMisc.ExternalIdsSchema,
});
//Promotion Token
exports.AnimalPromotionSchema = exports.GeneralPromotionDetails.merge(exports.AnimalPromotionDetailSchema);
exports.ProductPromotionSchema = exports.GeneralPromotionDetails.merge(exports.ProductPromotionDetailSchema);
